import { timeoutAfter } from './timeout';

/** 클라이언트 로그 클릭 최대 대기 시간 */
export const CLIENT_LOG_CLICK_TIMEOUT = 250;

/**
 * 최대 클라이언트 로그 클릭 대시 시간까지 기다린 후 종료
 * 클릭 로그 전송을 위해 이용됩니다.
 *
 * @example
 * ```
 * await waitUntilClickTimeout(() => {
 * 	// send click log
 * })
 * ```
 */
export const waitUntilClickTimeout = timeoutAfter(CLIENT_LOG_CLICK_TIMEOUT);
